import React, { useEffect, useState } from "react";
import { message, Spin } from "antd";
import dayjs from "dayjs";
import BreadcrumbBanner from "../components/BreadcrumbBanner";
import "./../style/order.css";
import "./../style/common.css";

const MyOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchOrders = async () => {
      const userId = localStorage.getItem("UserId");
      const token = localStorage.getItem("token");

      if (!userId || !token) {
        message.warning("Please log in to view your order history");
        return;
      }

      try {
        setLoading(true);

        const response = await fetch(
          "https://cafemandhurah.mandurahcafe.com.au/api/orders/by-user",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ user_id: Number(userId) }),
          }
        );

        const result = await response.json();

        if (response.ok) {
          setOrders(result.data || []);
        } else {
          throw new Error(result.message || "Failed to fetch orders");
        }
      } catch (err) {
        console.error(err);
        message.error("Failed to load order history");
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);

  return (
    <>
      <BreadcrumbBanner
        title="My Order History"
        backgroundImage="/Images/banner-about.jpg"
      />
      <div className="order-main">
        <div className="order-history-wrapper">
          <h2>Past Orders</h2>
          <Spin spinning={loading} tip="Loading orders..." className="loading">
            {orders.length === 0 ? (
              <p>No orders found.</p>
            ) : (
              <div className="order-grid">
                {orders.map((order) => (
                  <div className="order-card" key={order.id}>
                    <div className="order-header">
                      <div>
                        <strong>Order #:</strong> {order.order_number}
                      </div>
                    </div>
                    <div className="order-info">
                      <p>
                        <strong>Date:</strong>{" "}
                        {dayjs(order.delivery_time_slot).format(
                          "MMMM D, YYYY h:mm A"
                        )}
                      </p>
                      <p>
                        <strong>Total:</strong> ${order.final_amount}
                      </p>
                      <p>
                        <strong>Items:</strong>
                        {order.items && order.items.length > 0 ? (
                          <div className="order-items-list">
                            {order.items.map((item, idx) => (
                              <div className="order-item" key={idx}>
                                <span className="order-item-name">{item.name}</span>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <span> — </span>
                        )}
                      </p>

                      {order.choices && order.choices.length > 0 && (
                        <p>
                          <strong>Choices:</strong>
                          <ul>
                            {order.choices.map((choice, idx) => (
                              <li key={idx}>
                                + {choice.name} (${choice.price})
                              </li>
                            ))}
                          </ul>
                        </p>
                      )}

                      {order.notes && (
                        <p>
                          <strong>Notes:</strong> {order.notes}
                        </p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </Spin>
        </div>
      </div>
    </>
  );
};

export default MyOrders;
